const PRODUCT_RE = /\[\[product:(\/products\/[^\]]+)\]\]/;
const PRODUCTS_RE = /\[\[products:([^\]]+)\]\]/;
const COLLECTION_RE = /\[\[collection:(\/collections\/[^\];]+)(?:;([^\]]+))?\]\]/;

function parseEmbeds(container) {
  container.querySelectorAll('p').forEach((p) => {
    const text = p.textContent.trim();
    let match;

    match = text.match(PRODUCT_RE);
    if (match) {
      const div = document.createElement('div');
      div.dataset.editorial = 'product';
      div.dataset.url = match[1];
      p.replaceWith(div);
      return;
    }

    match = text.match(PRODUCTS_RE);
    if (match) {
      const urls = match[1].split(',').map((u) => {
        u = u.trim();
        return u.startsWith('/') ? u : '/' + u;
      }).filter(Boolean);
      const div = document.createElement('div');
      div.dataset.editorial = 'products';
      div.dataset.urls = JSON.stringify(urls);
      p.replaceWith(div);
      return;
    }

    match = text.match(COLLECTION_RE);
    if (match) {
      const div = document.createElement('div');
      const modifier = match[2] ? match[2].trim() : '';
      div.dataset.editorial = modifier === 'marquee' ? 'collection-marquee' : 'collection';
      div.dataset.url = match[1];
      p.replaceWith(div);
    }
  });
}

function extractSection(html) {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  // Section Rendering API wraps in <div id="shopify-section-...">
  const section = tmp.querySelector('[id^="shopify-section-"]');
  return section ? section.innerHTML : tmp.innerHTML;
}

async function fetchProductCard(url) {
  const res = await fetch(`${url}?section_id=editorial-product-card`);
  if (!res.ok) throw new Error(`${res.status}`);
  return extractSection(await res.text());
}

function insertHTML(el, html) {
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  const inserted = tmp.firstElementChild || tmp;
  el.replaceWith(inserted);
  blurUpImages(inserted);
  return inserted;
}

async function renderProduct(el, url) {
  insertHTML(el, await fetchProductCard(url));
}


function autoScrollCarousel(carousel) {
  let paused = false;
  carousel.addEventListener('mouseenter', () => { paused = true; });
  carousel.addEventListener('mouseleave', () => { paused = false; });
  carousel.addEventListener('touchstart', () => { paused = true; }, { passive: true });
  setInterval(() => {
    if (paused) return;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    if (carousel.scrollLeft >= maxScroll - 2) {
      carousel.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      const card = carousel.querySelector('product-card');
      carousel.scrollBy({ left: card ? card.offsetWidth : 200, behavior: 'smooth' });
    }
  }, 3000);
}

async function renderCollection(el, url) {
  const res = await fetch(`${url}?section_id=editorial-collection`);
  if (!res.ok) throw new Error(`${res.status}`);
  const inserted = insertHTML(el, extractSection(await res.text()));
  const carousel = inserted && inserted.querySelector('scroll-carousel');
  if (carousel) autoScrollCarousel(carousel);
}

async function renderMarquee(el, url) {
  const res = await fetch(`${url}?section_id=editorial-collection-marquee`);
  if (!res.ok) throw new Error(`${res.status}`);
  insertHTML(el, extractSection(await res.text()));
}

async function init() {
  const container = document.querySelector('.article__wrapper .prose');
  if (!container) return;

  parseEmbeds(container);

  const productEls = [...container.querySelectorAll('[data-editorial="product"]')];
  const productsEls = [...container.querySelectorAll('[data-editorial="products"]')];
  const collectionEls = [...container.querySelectorAll('[data-editorial="collection"]')];
  const marqueeEls = [...container.querySelectorAll('[data-editorial="collection-marquee"]')];

  await Promise.allSettled([
    ...productEls.map(async (el) => {
      try { await renderProduct(el, el.dataset.url); }
      catch { el.style.display = 'none'; }
    }),
    ...productsEls.map(async (el) => {
      try {
        const urls = JSON.parse(el.dataset.urls);
        const results = await Promise.allSettled(urls.map((u) => fetchProductCard(u)));
        const cards = results.filter((r) => r.status === 'fulfilled').map((r) => r.value);
        const count = cards.length;
        if (!count) { el.style.display = 'none'; return; }
        insertHTML(el, `
          <div class="editorial-collection">
            <div class="product-list" style="--product-list-items-per-row: ${count}; --product-list-max-items-per-row-allowed: ${count}; --product-list-horizontal-spacing-factor: 0.2; --product-list-vertical-spacing-factor: 0.2;">
              ${cards.join('')}
            </div>
          </div>`);
      } catch { el.style.display = 'none'; }
    }),
    ...collectionEls.map(async (el) => {
      try { await renderCollection(el, el.dataset.url); }
      catch { el.style.display = 'none'; }
    }),
    ...marqueeEls.map(async (el) => {
      try { await renderMarquee(el, el.dataset.url); }
      catch { el.style.display = 'none'; }
    }),
  ]);
}

function blurUpImages(root) {
  root.querySelectorAll('img').forEach((img) => {
    if (img.complete) return;
    img.style.filter = 'blur(8px)';
    img.style.transition = 'filter 0.4s ease';
    img.addEventListener('load', () => { img.style.filter = ''; }, { once: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
